/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./../lib/httpClient.ts";
import { GetEnvJson200ResponseDTO } from "././index.d.ts";

export class EnvJson<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get environment variables
   *
   * @tags env.json
   * @name GetEnvJson
   * @request GET:/env.json
   * @secure
   */
  getEnvJson = (params: RequestParams = {}) =>
    this.http.request<GetEnvJson200ResponseDTO, any>({
      path: `/env.json`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
